import { HTMLProps, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface SidebarSectionContentProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionContent = forwardRef<
  HTMLDivElement,
  SidebarSectionContentProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(className, classes.root)} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionContent.displayName = 'SidebarSection.Content';

export default withStyles(styles)(SidebarSectionContent);
